import { enqueueSnackbar, SharedProps } from 'notistack'
import { toast } from 'sonner'

export const setAlert = (
  mensagem: string,
  type: SharedProps['variant'],
  time?: number,
): void => {
  enqueueSnackbar(mensagem, {
    preventDuplicate: false,
    persist: !time,
    autoHideDuration: time,
    variant: type,
  })
}

// Sonner (padronizado no topo à direita também)
export const setError = (mensagem: string, time?: number): void => {
  toast.error(mensagem, { duration: time, position: 'top-right' })
}

export const setInfo = (mensagem: string, time = 5000): void => {
  toast.info(mensagem, { duration: time, position: 'top-right' })
}

export const setSuccess = (mensagem: string, time = 2000): void => {
  toast.success(mensagem, { duration: time, position: 'top-right' })
}

export const setWarning = (mensagem: string, time = 5000): void => {
  toast.warning(mensagem, { duration: time, position: 'top-right' })
}
